module.exports = __webpack_public_path__ + "static/media/icon-discovery.a648f6ce.svg";